/**
 * @module RouterService
 * @description The RouterService singleton is a temporary solution to allow the navigation using
 * the legacy Backbone Router and the new Vue Router. After migrating all the legacy routes,
 * this service won't be needed.
 */
export default {
  /**
   * Validate whether legacy viewport exists or not.
   * This is a temporary method until completing the
   * migration of all the legacy routes.
   */
  redirect({
    vueRouter,
    path,
    viewport = null,
    triggeredEvent = null,
  }) {
    const actionRules = {
      viewportOnly: {
        check: () => viewport && !triggeredEvent,
        act: (actPath) => {
          viewport.redirect(actPath);
        },
      },
      viewportWithTrigger: {
        check: () => viewport && triggeredEvent,
        act: (actPath) => {
          viewport.trigger(triggeredEvent);
          viewport.redirect(actPath);
        },
      },
      default: {
        check: () => true,
        act: (actPath) => {
          vueRouter.push({ path: actPath }).catch(() => {});
        },
      },
    };

    const action = Object.values(actionRules).find(rule => rule.check());

    action.act(path);
  },
};
